import classNames from 'classnames';
import getBlockDepth from './getBlockDepth';
var CSS_BASE_CLASSNAME = 'slite-editor';

function getBlockClassName(node) {
  return classNames("".concat(CSS_BASE_CLASSNAME, "-block"), "".concat(CSS_BASE_CLASSNAME, "-block--depth-").concat(getBlockDepth(node)));
}

export default getBlockClassName;